import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import LoadScript from "vue-plugin-load-script";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import moment from "moment";
import Meta from "vue-meta";
import dotenv from "dotenv";
// import VueCryptojs from "vue-cryptojs";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import "primeicons/primeicons.css";
import ConfigPlugin from "./plugins/configPlugin";


// Vue.use(VueCryptojs);

dotenv.config();

Vue.config.productionTip = false;

// ---- Disable zoom in / zoom out (app-wide) ----
// Viewport `user-scalable=no` alone is ignored on iOS 10+, so block the
// gestures that drive zoom while keeping normal scroll/tap intact.
document.addEventListener('gesturestart', (e) => e.preventDefault());
document.addEventListener('dblclick', (e) => e.preventDefault(), { passive: false });
document.addEventListener(
  'wheel',
  (e) => {
    if (e.ctrlKey) e.preventDefault();
  },
  { passive: false }
);
document.addEventListener('keydown', (e) => {
  if (
    (e.ctrlKey || e.metaKey) &&
    ['+', '-', '=', '0'].includes(e.key)
  ) {
    e.preventDefault();
  }
});
document.addEventListener(
  'touchmove',
  (e) => {
    if (e.touches && e.touches.length > 1) e.preventDefault();
  },
  { passive: false }
);

Vue.use(LoadScript);
Vue.use(VueSweetalert2);
Vue.use(Meta);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueMaterial)
Vue.use(ConfigPlugin); // register ConfigPlugin

Vue.prototype.moment = moment;

router.beforeEach(async (to, from, next) => {
  try {
    await Vue.prototype.$configService.getConfig(); // always check cache + API if expired
    next();
  } catch (err) {
    console.error("Failed to fetch config:", err);
    next(); // still allow navigation even if config fails
  }
});

Vue.loadScript("/js/kbzpay.js").then(async() => {
    Vue.prototype.kbzpay = window.kbzpay;
    await Vue.prototype.$configService.getConfig();

    new Vue({
        router,
        store,
        render: (h) => h(App),
    }).$mount("#app");
});
